import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
const unitTranslations = {
  second: "ثانية",
  millisecond: "مللي ثانية",
  microsecond: "ميكروثانية",
  nanosecond: "نانوثانية",
  picosecond: "بيكوثانية",
  minute: "دقيقة",
  hour: "ساعة",
  day: "يوم",
  week: "أسبوع",
  month: "شهر",
  year: "سنة",
};
const timeConversions = {
  second: 1,
  millisecond: 1e-3,
  microsecond: 1e-6,
  nanosecond: 1e-9,
  picosecond: 1e-12,
  minute: 60,
  hour: 3600,
  day: 86400,
  week: 604800,
  month: 2.628e6,
  year: 3.154e7,
};
const convertTime = (amount, fromTimeUnit, toTimeUnit) => {
  const fromInSeconds = amount * timeConversions[fromTimeUnit];
  return fromInSeconds / timeConversions[toTimeUnit];
};
function TimeConverter() {
  const { fromTimeUnit, toTimeUnit } = useParams();
  const [amount, setAmount] = useState(1);
  const [convertedAmount, setConvertedAmount] = useState(null);
  const [storedAmount, setStoredAmount] = useState("");
  const translatedFromUnit = unitTranslations[fromTimeUnit] || fromTimeUnit;
  const translatedToUnit = unitTranslations[toTimeUnit] || toTimeUnit;
  const TITLE = `تحويل من ${translatedFromUnit} إلى ${translatedToUnit}`;
  const DESCRIPTION = `استخدم محول الوحدات المتقدم لدينا لتحويل دقيق بين ${translatedFromUnit} و${translatedToUnit}. قم بحساب وتحويل كميات ${translatedFromUnit} إلى ${translatedToUnit} بسرعة وسهولة باستخدام أدوات التحويل الفعالة لدينا. مثالي لتحويل الوحدات في الحسابات اليومية والاحترافية.`;
  const KEYWORDS = `تحويل وحدات, ${translatedFromUnit} إلى ${translatedToUnit}, ${fromTimeUnit} إلى ${toTimeUnit}, محول وحدات, أدوات تحويل`;
  const OG_URL = `https://do-calculate.com/calculator/ar/unit_converter/time/${fromTimeUnit}/${toTimeUnit}`;
  useEffect(() => {
    setConvertedAmount(null);
  }, [fromTimeUnit, toTimeUnit]);
  const handleCalculate = () => {
    if (amount) {
      setStoredAmount(amount);
      const result = convertTime(amount, fromTimeUnit, toTimeUnit);
      setConvertedAmount(result.toFixed(10));
    } else {
      setConvertedAmount("0");
    }
  };
  const amounts = [1, 5, 10, 20, 50, 100, 200, 500, 1000, 2000, 5000, 10000];
  amounts.sort((a, b) => a - b);
  const conversionTable = amounts.map((a) => ({
    fromAmount: a,
    toAmount: convertTime(a, fromTimeUnit, toTimeUnit).toFixed(10),
  }));
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  مرحبًا بك في أداة <strong>تحويل الوحدات</strong> الرائدة
                  لدينا! مع <strong>محول الوحدات</strong> هذا، يمكنك بسهولة
                  تحويل الوحدات من <strong>{translatedFromUnit}</strong> إلى{" "}
                  <strong>{translatedToUnit}</strong> والعكس. هل تحتاج إلى{" "}
                  <strong>
                    تحويل {translatedFromUnit} إلى {translatedToUnit}
                  </strong>
                  ؟ أو ربما{" "}
                  <strong>
                    تحويل {translatedToUnit} إلى {translatedFromUnit}
                  </strong>
                  ؟ هذه الأداة توفر لك الحل المثالي. استخدم{" "}
                  <strong>محول الوحدات</strong> لتحويل مقادير{" "}
                  <strong>{translatedFromUnit}</strong> إلى{" "}
                  <strong>{translatedToUnit}</strong> بدقة وسرعة، أو العكس،
                  لتحصل على النتائج التي تحتاجها. سواء كنت بحاجة إلى{" "}
                  <strong>تحويل {translatedFromUnit}</strong> إلى{" "}
                  <strong>{translatedToUnit}</strong> لأغراض مختلفة، فمحول
                  الوحدات هذا هو الأداة المثالية لذلك.
                </p>
                <hr />
              </div>
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>
                    {translatedFromUnit} إلى {translatedToUnit}
                  </h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div>
                    <div className="alert alert-info">
                      <b>1 </b> {translatedFromUnit} يساوي{" "}
                      <b>
                        {convertTime(1, fromTimeUnit, toTimeUnit).toFixed(10)}
                      </b>{" "}
                      {translatedToUnit}
                      <br />
                    </div>
                    <hr />
                    <div
                      className="form-group d-flex align-items-center"
                      htmlFor="amount"
                    >
                      <b>
                        <label className="form-label ms-2">
                          ادخل القيمة بالـ {translatedFromUnit}
                        </label>
                      </b>
                      <input
                        id="amount"
                        type="number"
                        value={amount}
                        onChange={(e) =>
                          setAmount(parseFloat(e.target.value) || 0)
                        }
                        placeholder="أدخل القيمة"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                    <Link
                      to={`/calculator/ar/unit_converter/time/${toTimeUnit}/${fromTimeUnit}/`}
                    >
                      <button
                        className="text-white bg-secondary"
                        style={{ padding: "4px" }}
                      >
                        تحويل من {translatedToUnit} إلى {translatedFromUnit}
                      </button>
                    </Link>
                  </div>
                  <br />
                  {convertedAmount &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <p className="text-white">
                        {storedAmount} {translatedFromUnit} = {convertedAmount}{" "}
                        {translatedToUnit}{" "}
                      </p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
              <div>
                <br />
                <p className="alert alert-success">
                  ان كل <b>1 (واحد)</b> {translatedFromUnit} يساوي{" "}
                  <b>{convertTime(1, fromTimeUnit, toTimeUnit).toFixed(10)}</b>{" "}
                  {translatedToUnit} وفيما يلي جدول يظهر السعر لبعض الفئات:
                </p>
                <table >
                  <thead>
                    <tr>
                      <th >{translatedFromUnit}</th>
                      <th >{translatedToUnit}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {conversionTable.map((entry, index) => (
                      <tr key={index}>
                        <td>
                          {entry.fromAmount} {translatedFromUnit}
                        </td>
                        <td>
                          {entry.toAmount} {translatedToUnit}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <MainCalculatorsList></MainCalculatorsList>
          <br/>        </div>
         </div>
</div>
  );
}
export default TimeConverter;
